import { render, staticRenderFns } from "./NewUserPage.vue?vue&type=template&id=802163f8&"
import script from "./NewUserPage.vue?vue&type=script&lang=js&"
export * from "./NewUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports